<!-- <ng-container *ngIf="currentStep; let step"> -->
  
  <!-- <mat-progress-bar color="accent" *ngIf="loadingPage" mode="indeterminate"></mat-progress-bar> -->
<ng-container *ngIf="(currentStepObs$ | async); let step">
  <div fxLayout="row wrap">

    <!--Current Step Form-->
    <div id="currentstepanchor" style="width: 100%;">
      <mat-card fxFlex="100%" >
        <mat-card-title class="pl-24 mt-12">
          {{step.workflowStepTitle}}
        </mat-card-title>

      <div *ngIf="step.form && !reOpenCaseMode && !viewMode">
        <app-form-component [formData]="step.form" [readonly]="step.readonly || step.status != 'Pending' || readonly">
        </app-form-component>
      </div>

      <div *ngIf="step.form && !reOpenCaseMode && viewMode">
        <app-form-component [formData]="step.form" [readonly]="step.readonly || step.status != 'Pending' || readonly || viewMode">
        </app-form-component>
      </div>

      <div *ngIf="reOpenCaseMode">
        <app-form-component [formData]="reOpenedForm" [readonly]="readonly">
        </app-form-component>
      </div>
    </mat-card>
    </div>

    <!--Review Form-->
    <div id="reviewAnchor" class="mb-12 w-100-p"
        *ngIf="step.status == 'ToReview' && step.canReview && !readonly">
      <mat-card *ngIf="step.status == 'ToReview' && step.canReview && !readonly" fxFlex="100%" class="mt-8">
        <mat-card-title class="pl-24 mt-12 mb-4">
          {{"WORKFLOW.REVIEW" | translate}}
        </mat-card-title>

        <mat-card-content>
          <div class="mb-12">
            <mat-radio-group [formControl]="actionToDo">
              <mat-radio-button *ngFor="let action of step.reviewActions" [value]="action" class="p-4"
                style="width: 100%">
                {{("WORKFLOWS.ACTIONS." + action) | translate}}
              </mat-radio-button>
            </mat-radio-group>
          </div>

          <div *ngIf="actionToDo.value == 'NextStep' || actionToDo.value == 'JumpNextStep'">
            <app-assigned-team [stakeholdersConfig]="step.stakeholders" editable="true"
              (assignedResponders)="handleAssignedTeamData($event)">
            </app-assigned-team>
          </div>

          <div *ngIf="actionToDo.value == 'Resolved' || actionToDo.value == 'Discarded'" fxLayout="row wrap">
            <mat-form-field appearance="fill" fxFlex="100%" class="mb-8">
              <mat-label>{{'ALERTS.COMPLETE_ALERT.BUTTONS.ADD_NEW' | translate}}</mat-label>
              <textarea matInput rows="6" [formControl]="reason" #textarea [maxlength]="maxlength"
                class="pt-16"></textarea>
              <mat-hint align="end">{{textarea.value.length}} / {{maxlength}}</mat-hint>
            </mat-form-field>

          </div>

          <div *ngIf="actionToDo.value == 'AssociateToAnotherAlert'">
            <app-associate-alert (idSelectedEmitter)="selectAssociatedAlert($event)"></app-associate-alert>
          </div>

          <div *ngIf="actionToDo.value == 'RequestOpenANewCase'">
            <app-request-open-case (openCaseData)="setNewCaseData($event)"></app-request-open-case>
          </div>

          <div *ngIf="actionToDo.value == 'ClosedWithTakingAction'">
            <app-select-follow-up-actions [workflowInstanceId]="workflowInstanceId"
              (followUpTaskChange)="onChageFollowUpTask($event)"></app-select-follow-up-actions>
          </div>
        </mat-card-content>

        <mat-card-actions align="end">
          <button mat-raised-button color="accent" class="m-8" (click)="finalizeStepInstance()" [disabled]="reviewLoading || !actionToDo.value">
            {{"BUTTONS.REVIEW" | translate}}</button>
        </mat-card-actions>
      </mat-card>
    </div>

    <mat-divider *ngIf="step.status == 'ToReview' && step.canReview && !readonly"></mat-divider>

    <!--Consultants Panel-->
    <app-consultants-panel 
      *ngIf="step.canGenerateSections"
      style="width: 100%;"
      [viewMode]="viewMode || readonly"
      [canAddDeleteSections]="step.canRespond || step.canReview"
      [currentStepStatus]="step.status"
      [sections]="step.sections"
      (sectionsEmitter)="updateSections($event)"
      (sectionsToSave)="sectionsToSave($event)">
    </app-consultants-panel>
  </div>
</ng-container>